import { Navigate } from "react-router-dom";
import useAuthChecker from "../../Logic/Auth/useAuthChecker";

const ProtectedRoute = ({ children }) => {
  const { isAuthCompleted, isToken } = useAuthChecker();

  if (!isAuthCompleted) {
    return <Navigate to="/login" />;
  } else if (isToken === null) {
    return <Navigate to="/" />;
  }
  return children;
};
export default ProtectedRoute;
